
import React, { useState,useEffect} from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import DialogForm from '../components/DialogForm';

import './components.css'


const Footer = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const openDialogPopup = () => {
      setIsDialogOpen(true);
    };
  
    const closeDialogPopup = () => {
      setIsDialogOpen(false);
    };
    
  return (
    <>
    <section  id="contactUs" style={{backgroundColor:'#eeee'}}> 
      
   <div className=" d-grid p-5" style={{letterSpacing:'1px'}}>
    <div className="d-md-flex" >
   <div style={{paddingRight:'100px'}}>
        <div className="d-grid"  >
        <h5 className="pt-1" style={{color:'rgb(134, 198, 39)'}}>Address</h5>
                <p style={{color:'black'}}>BuildFortune <br></br>2/4,Kodigehalli road,Sadaramangala, <br></br>Bengaluru,Karnataka <br></br>560067. India</p>
                </div>
                <div className="d-grid">
        <h5 style={{color:'rgb(134, 198, 39)'}}>Reach Out Us</h5>
                <p style={{color:'black'}}>Email: buildfortunec2c@gmail.com<br></br>Call Us: 9740890386 , 8217210038</p>
                </div>
                </div>
                <div>
                 <h5 style={{color:'rgb(134, 198, 39)'}}>Links</h5>
                 <p>   <a href="#aboutUs" target="_parent" style={{textDecoration:'none',color:'black',letterSpacing:'1px'}} >About</a><br></br> <a href="#features" target="_parent" style={{color:'black',textDecoration:'none',letterSpacing:'1px'}}>Features<br></br> <a href="#projects" target="_parent" style={{color:'black',textDecoration:'none',letterSpacing:'1px'}}>Projects</a></a><br></br><a href="#howwework" target="_parent" style={{textDecoration:'none',color:'black',letterSpacing:'1px'}} >How We Work</a><br></br> <a href="#faq" target="_parent" style={{color:'black',textDecoration:'none',letterSpacing:'1px'}}>FAQ</a></p>
                 <button type="button" className=" btn btn-small text-white" style={{backgroundColor:'hsl(255, 93%, 30%)',border:'none',borderRadius:'0px',letterSpacing:'1px'}} onClick={openDialogPopup}>Send Inquiry</button>
                 <DialogForm isOpen={isDialogOpen} onClose={closeDialogPopup}/> 
                </div>
               
                </div>
           

                <div className="iframe">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15549.889744224776!2d77.73239!3d13.0055591!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae11c66cceac8b%3A0x49099926371a4cb4!2sBUILDFORTUNE!5e0!3m2!1sen!2sin!4v1710247189463!5m2!1sen!2sin"  ></iframe>
                </div>         
    </div>
   </section>
       <div className="text-center p-4" style={{backgroundColor:"rgba(0,0,0,1)"}}>
       <p style={{fontSize:'small',color:'gray',fontWeight:'bold'}}>Copyright <i class="bi bi-c-circle" ></i> 2024 BuildFortune Construction. All Rights Reserved.</p>
       </div>
       </>
  )
}

export default Footer
